<template>
  <b-container v-if="!isLoadingGet" fluid="lg">
    <b-row class="justify-content-center my-5">
      <!-- // NOTE: Show only when BuildingOwner exists and is an object  -->
      <b-col v-if="item" sm="10" md="9" lg="6">
        <b-col cols="12">
          <b-row class="mb-4">
            <h3>Profile Info</h3>
          </b-row>
        </b-col>
        <b-row>
          <b-col>
            <ValidationObserver ref="form" tag="form">
              <form>
                <b-row class="my-3 justify-content-center d-none">
                  <b-col cols="12">
                    <b-row>
                      <b-col cols="6">
                        <b-button
                          class="btn-block"
                          squared
                          :class="{
                            'btn-primary': item.entity_type == entityTypes.individual,
                            'btn-outline-primary': item.entity_type != entityTypes.individual,
                          }"
                          variant="none"
                          @click="setEntityType(entityTypes.individual, 'buildingOwner')"
                        >
                          <strong>Particulier</strong>
                        </b-button>
                      </b-col>
                      <b-col cols="6">
                        <b-button
                          class="btn-block"
                          squared
                          variant="none"
                          :class="{
                            'btn-primary': item.entity_type == entityTypes.legal,
                            'btn-outline-primary': item.entity_type != entityTypes.legal,
                          }"
                          @click="setEntityType(entityTypes.legal)"
                        >
                          <strong>Professionnel</strong>
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="mb-3">
                  <b-col
                    v-if="item.entity_type == entityTypes.individual"
                    sm="6"
                    class="mb-3 mb-sm-0"
                  >
                    <ValidationProvider v-slot="{ errors }" name="Last Name" rules="required">
                      <label>Last Name</label>
                      <b-input
                        v-model="item.lastname"
                        disabled
                        @input="updateItem('lastname', $event)"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                  <b-col v-else sm="12" class="mb-3 mb-sm-0">
                    <ValidationProvider v-slot="{ errors }" name="Company" rules="required">
                      <label>Company</label>
                      <b-input
                        v-model="item.lastname"
                        disabled
                        @input="updateItem('lastname', $event)"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                  <b-col v-if="item.entity_type == entityTypes.individual" sm="6">
                    <ValidationProvider v-slot="{ errors }" name="First Name" rules="alpha">
                      <label>First Name</label>
                      <b-input
                        v-model="item.firstname"
                        disabled
                        @input="updateItem('firstname', $event)"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row class="mb-3">
                  <b-col sm="6">
                    <ValidationProvider v-slot="{ errors }" name="Country" rules="alpha">
                      <label>Country</label>
                      <b-form-select
                        disabled
                        :value="item.country.toUpperCase()"
                        :options="countryOptions"
                        @input="updateItem('country', $event)"
                      >
                      </b-form-select>
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                  <b-col sm="6">
                    <ValidationProvider v-slot="{ errors }" name="City" rules="alpha">
                      <label>City</label>
                      <b-input v-model="item.city" disabled @input="updateItem('city', $event)" />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row class="mb-3">
                  <b-col>
                    <ValidationProvider v-slot="{ errors }" name="Address" rules="required">
                      <label>Address: no de rue, rue</label>
                      <b-input
                        v-model="item.address"
                        disabled
                        @input="updateItem('street', $event)"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                  <b-col>
                    <label>Complement</label>
                    <b-input
                      v-model="item.complement"
                      disabled
                      @input="updateItem('street', $event)"
                    />
                  </b-col>
                </b-row>
                <b-row class="mb-3">
                  <b-col sm="6">
                    <ValidationProvider v-slot="{ errors }" name="Zipcode" rules="required">
                      <label>Zipcode</label>
                      <b-input
                        v-model="item.zipcode"
                        disabled
                        @input="updateItem('zipcode', $event)"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                  <b-col sm="6">
                    <label>Complement 2</label>
                    <b-input
                      v-model="item.complement2"
                      disabled
                      @input="updateItem('complement2', $event)"
                    />
                  </b-col>
                </b-row>
                <b-row class="mb-3">
                  <b-col sm="6">
                    <ValidationProvider v-slot="{ errors }" name="Email" rules="email">
                      <label>Email</label>
                      <b-input v-model="item.email" disabled @input="updateItem('email', $event)" />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                  <b-col sm="6" class="mb-3 mb-sm-0">
                    <label>Phone</label>
                    <b-input v-model="item.phone" disabled @input="updateItem('phone', $event)" />
                  </b-col>
                </b-row>
              </form>
            </ValidationObserver>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" sm="10" md="6" offset-md="3" offset-sm="1">
        <label>Timezone</label>
        <v-select
          ref="v-select"
          v-model="timezone"
          :clearable="false"
          class=""
          :options="timezones"
          @input="selectTimezone($event)"
        >
        </v-select>
      </b-col>
    </b-row>
    <b-row class="my-5 justify-content-center">
      <b-col cols="auto">
        <b-button variant="light" class="button text-danger" @click="logout">
          <font-awesome-icon class="agv-button-icon" icon="sign-out-alt" />
          <span class="mr-2">Logout</span>
        </b-button>
      </b-col>
    </b-row>
  </b-container>
  <appLoader v-else />
</template>

<script>
import BuildingOwnerORM from "@/store/orm-axios/models/BuildingOwner";
import ContactORM from "@/store/orm-axios/models/Contact";
import MeetingGuestORM from "@/store/orm-axios/models/MeetingGuest";
import UserORM from "@/store/orm-axios/models/User";

export default {
  data() {
    return {
      userId: localStorage.getItem("userId"),
      isLoadingGet: true,
      isLoadingSave: false,
      item: null,
      timezone: null,
    };
  },
  computed: {
    user() {
      return UserORM.find(this.userId);
    },
    BuildingOwner() {
      return BuildingOwnerORM.find(this.building_owner_id);
    },
    contact() {
      return ContactORM.find(this.contact_id);
    },
    meetingQuest() {
      return MeetingGuestORM.find(this.meeting_guest_id);
    },
    allCountries() {
      return this.$store.getters.getCountries;
    },
    countryOptions() {
      let result = [];
      this.allCountries.forEach(element => {
        result.push({
          value: element.countryCode,
          text: element.countryName,
        });
      });
      return result;
    },
    timezones() {
      return this.$moment.tz.names();
    },
    defaultTimezone() {
      return localStorage.getItem("timezone");
    },
  },
  async created() {
    if (this.userId) {
      await UserORM.api()
        .GET(this.userId)
        .then(res => {
          this.isLoadingGet = false;
        })
        .catch(err => {
          this.isLoadingGet = false;
        });
    }
    if (this.building_owner_id) {
      await BuildingOwnerORM.api()
        .GET_BY_USER_ID(this.userId)
        .then(() => {
          this.isLoadingGet = false;
        })
        .catch(err => {
          this.isLoadingGet = false;
        });
      this.item = this.BuildingOwner;
    } else if (this.contact_id) {
      await ContactORM.api().GET(this.contact_id);
      this.isLoadingGet = false;
      this.item = this.contact;
    } else if (this.meeting_guest_id) {
      this.isLoadingGet = false;
      // TODO Logic when is quest
      // this.item = this.meetingQuest;
    }

    if (!this.defaultTimezone) {
      this.setTimezone("Europe/Paris");
    } else if (this.user && this.user.timezone) {
      this.timezone = this.user.timezone;
    } else {
      this.timezone = this.defaultTimezone;
    }
  },
  methods: {
    // ???: d-none
    setEntityType(type) {
      if (this.BuildingOwner) {
        BuildingOwnerORM.update({
          where: this.building_owner_id,
          data: { entity_type: type },
        });
      } else if (this.contact) {
        ContactORM.update({
          where: this.building_owner_id,
          data: { entity_type: type },
        });
      }
    },
    logout() {
      this.$store.dispatch("auth/logout").then(() => {
        this.$parent.selectedBuilding = null;
        this.$router.push({ name: "login" });
      });
    },
    getCountryName(countryCode) {
      let foundCountry = this.$_.find(this.allCountries, country => {
        return country.countryCode == countryCode.toUpperCase();
      });
      if (foundCountry) {
        return foundCountry.countryName;
      } else {
        return "";
      }
    },
    selectTimezone(timezone) {
      this.setTimezone(timezone);
    },
    setTimezone(timezone) {
      this.$moment.tz.setDefault(timezone);
      localStorage.setItem("timezone", timezone);
      this.user.timezone = timezone;
      this.UPDATE_USER();
    },
    UPDATE_USER() {
      UserORM.api().PUT(this.user);
    },
  },
};
</script>
